<template>
  <div class="welcome-page">
    <div class="welcome-card">
      <img src="@/assets/logo.png" alt="Snap Drive" class="welcome-logo" />

      <div class="avatar" v-if="initial">{{ initial }}</div>

      <div class="welcome-text">
        Welcome, <span class="welcome-name">{{ displayName }}</span>
      </div>
      <div class="welcome-subtitle">Snap Drive Charge Center</div>

      <div class="user-info">
        <div class="info-row">
          <v-icon class="info-icon">person</v-icon>
          <div class="info-content">
            <span class="info-label">Name</span>
            <span class="info-value">{{ displayName || "—" }}</span>
          </div>
        </div>
        <div class="info-row">
          <v-icon class="info-icon">email</v-icon>
          <div class="info-content">
            <span class="info-label">Email</span>
            <span class="info-value">{{ email || "—" }}</span>
          </div>
        </div>
        <div class="info-row">
          <v-icon class="info-icon">phone</v-icon>
          <div class="info-content">
            <span class="info-label">Phone</span>
            <span class="info-value">{{ phone || "—" }}</span>
          </div>
        </div>
        <div class="info-row">
          <v-icon class="info-icon">place</v-icon>
          <div class="info-content">
            <span class="info-label">Address</span>
            <span class="info-value">{{ address || "—" }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  title: "Home",
  computed: {
    user() {
      return this.$store.state.user || {};
    },
    displayName() {
      return this.user.name || "";
    },
    email() {
      return this.user.username || "";
    },
    phone() {
      return this.user.phone_number || "";
    },
    address() {
      return this.user.address || "";
    },
    initial() {
      const name = this.displayName.trim();
      return name ? name.charAt(0).toUpperCase() : "";
    },
  },
};
</script>

<style scoped>
.welcome-page {
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 48px 16px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f7faf7 0%, #ffffff 100%);
}

.welcome-card {
  width: 100%;
  max-width: 520px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.04);
  padding: 40px 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.welcome-logo {
  width: 100%;
  max-width: 180px;
  height: auto;
  margin-bottom: 16px;
}

.avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4caf50 0%, #2e7d32 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 16px;
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.35);
}

.welcome-text {
  font-size: 24px;
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 4px;
}

.welcome-name {
  font-weight: 700;
  color: #2e7d32;
}

.welcome-subtitle {
  font-size: 14px;
  color: #8a96a3;
  margin-bottom: 28px;
  letter-spacing: 0.3px;
}

.user-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
}

.info-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 16px;
  background: #f7faf7;
  border: 1px solid #ecf2ec;
  border-radius: 10px;
  transition: background 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
}

.info-row:hover {
  background: #f0f7f1;
  border-color: #d6e8d7;
  transform: translateY(-1px);
}

.info-icon {
  color: #4caf50 !important;
  font-size: 22px !important;
  background: #e8f5e9;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.info-content {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #8a96a3;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.info-value {
  font-size: 15px;
  color: #2c3e50;
  font-weight: 500;
  word-break: break-word;
  line-height: 1.4;
  white-space: pre-wrap;
}

@media (max-width: 600px) {
  .welcome-page {
    padding: 24px 12px;
  }
  .welcome-card {
    padding: 32px 20px 24px;
    border-radius: 12px;
  }
  .welcome-logo {
    max-width: 140px;
  }
  .avatar {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }
  .welcome-text {
    font-size: 20px;
  }
  .welcome-subtitle {
    font-size: 13px;
    margin-bottom: 20px;
  }
  .info-row {
    padding: 12px 14px;
    gap: 12px;
  }
  .info-value {
    font-size: 14px;
  }
}
</style>
